import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [],
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addItem(state, action) {
      const newItem = action.payload.item;
      const quantity = action.payload.quantity;
      const existingItem = state.items.find(
        (item) => item.id === newItem.id && (item.id_variante || null) === (newItem.id_variante || null)
      );

      if (existingItem) {
        existingItem.quantidade += quantity;
      } else {
        state.items.push({
          ...newItem,
          quantidade: quantity,
        });
      }
    },
    removeItem(state, action) {
      const id = action.payload;
      state.items = state.items.filter((item) => {
        if (typeof id === "object") {
          return !(item.id === id.id && (item.id_variante || null) === (id.id_variante || null));
        }
        return item.id !== id;
      });
    },
    clearCart(state) {
      state.items = [];
    },
  },
});

export const { addItem, removeItem, clearCart } = cartSlice.actions;
export default cartSlice.reducer;
